import React, { lazy } from 'react';
const tomes = [{
  label: 'Tomo 1',
  sublabel: 'Primera Consulta',
  image: 'https://cdn.magicpatterns.com/uploads/voJQWh3jhsWJi3rNUVz4th/Gemini_Generated_Image_ua3lbsua3lbsua3l.webp'
}, {
  label: 'Tomo 2',
  sublabel: '30 Planes Listos',
  image: 'https://cdn.magicpatterns.com/uploads/mpoNoFqiLVsZb6MpZMSZ4e/Gemini_Generated_Image_5usuts5usuts5usu.webp'
}, {
  label: 'Tomo 3',
  sublabel: 'Educación Alimentaria',
  image: 'https://cdn.magicpatterns.com/uploads/kk1dCjqrtMhs8coHUy6XWh/Captura_de_pantalla_2026-04-23_141342.webp'
}, {
  label: 'Tomo 4',
  sublabel: 'Seguimiento',
  image: 'https://cdn.magicpatterns.com/uploads/dPVkj5rFnJr3cpRGZNtdMY/Gemini_Generated_Image_qdzsphqdzsphqdzs.webp'
}, {
  label: 'Tomo 5',
  sublabel: '100 Recetas Clínicas',
  image: 'https://cdn.magicpatterns.com/uploads/nBMnsuhXiGoJiGyC2EGUz9/Gemini_Generated_Image_aktn6aaktn6aaktn.webp'
}, {
  label: 'Tomo 6',
  sublabel: 'Alto Valor',
  image: 'https://cdn.magicpatterns.com/uploads/3MhrduCfiVcMDgZWUYYz29/Gemini_Generated_Image_3v30fd3v30fd3v30.jpg'
}];
const features = ['✅ Sistema de primera consulta listo en 60 minutos', '✅ 30 planes personalizables por patología y paciente', '✅ 100 recetas clínicas listas para entregar', '✅ Protocolos de seguimiento + material educativo imprimible'];
export function ProductShowcase() {
  return <section className="w-full px-4 sm:px-6 lg:px-8 py-10 text-gray-900 text-base leading-6" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(240,253,244) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-258">
      <div className="mx-auto max-w-4xl text-center" data-id="element-259">
        {/* Badge */}
        <div className="mb-6 inline-flex items-center gap-2 text-xs font-bold tracking-wide text-green-700 border border-green-700/50 bg-green-700/5 rounded-full px-4 py-1.5" data-id="element-260">
          🏆 El sistema clínico más completo para nutricionistas de Argentina
        </div>

        {/* Subtitle */}
        <h3 className="text-xl font-bold text-green-700 m-0 mb-4" data-id="element-261">
          MEGAPACK NUTRICIÓN RESUELTA
        </h3>

        {/* Description */}
        <p className="max-w-2xl text-gray-800 m-0 mb-8 text-[14px]" data-id="element-262">
          <strong data-id="element-263">
            6 Tomos + 6 Bonos — Sistema Clínico Completo — Todo resuelto.
          </strong>
          <br data-id="element-264" />
          +400 páginas · 30 planes listos para personalizar · 100 recetas
          clínicas · Protocolos de primera consulta · Material educativo
          imprimible · Sistema de seguimiento · 15 casos clínicos resueltos ·
          Listo para usar hoy.
        </p>

        {/* Tomes Grid */}
        <div className="relative mx-auto max-w-3xl mb-12" data-id="element-265">
          <div className="grid grid-cols-6 gap-3" data-id="element-266">
            {tomes.map(tome => <div key={tome.label} className="flex flex-col items-center gap-2" data-id="element-267">
                {/* Card con imagen */}
                <div className="w-full aspect-[3/4] rounded-xl overflow-hidden shadow-lg border border-gray-100" data-id="element-268">
                  <img src={tome.image} alt={`${tome.label} — ${tome.sublabel}`} width={180} height={240} loading="lazy" decoding="async" className="w-full h-full object-cover" data-id="element-269" />
                </div>

                {/* Título separado abajo */}
                <div className="text-center" data-id="element-270">
                  <span className="block text-[11px] sm:text-xs font-black text-gray-900" data-id="element-271">
                    {tome.label}
                  </span>
                  <span className="block text-[9px] sm:text-[10px] text-gray-500 leading-tight mt-0.5" data-id="element-272">
                    {tome.sublabel}
                  </span>
                </div>
              </div>)}
          </div>

          {/* Badge inferior */}
          <div className="mt-6 flex justify-center" data-id="element-273">
            <div className="whitespace-nowrap bg-green-700 text-[10px] font-black text-white rounded-full px-4 py-1.5 shadow-sm" data-id="element-274">
              6 TOMOS COMPLETOS · SISTEMA CLÍNICO PROFESIONAL
            </div>
          </div>
        </div>

        {/* Feature Tags */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-2xl mx-auto" data-id="element-275">
          {features.map(feature => <div key={feature} className="flex items-center gap-2.5 bg-green-700/5 border border-green-700/20 rounded-xl px-4 py-3 text-left" data-id="element-276">
              <span className="flex-shrink-0 w-5 h-5 rounded-full bg-green-700/15 flex items-center justify-center" data-id="element-277">
                <svg className="w-3 h-3 text-green-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3} data-id="element-278">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" data-id="element-279" />
                </svg>
              </span>
              <span className="text-xs font-semibold text-gray-800 leading-snug" data-id="element-280">
                {feature.replace('✅ ', '')}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}